"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DateTimeless", {
  enumerable: true,
  get: function () {
    return _DateTimeless.default;
  }
});
Object.defineProperty(exports, "EditReadings", {
  enumerable: true,
  get: function () {
    return _EditReadings.default;
  }
});
Object.defineProperty(exports, "Editing", {
  enumerable: true,
  get: function () {
    return _editing.default;
  }
});
Object.defineProperty(exports, "LocationType", {
  enumerable: true,
  get: function () {
    return _LocationType.default;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "deriveSkipReadings", {
  enumerable: true,
  get: function () {
    return _deriveSkipReadings.default;
  }
});
Object.defineProperty(exports, "flattenGpsReadings", {
  enumerable: true,
  get: function () {
    return _flattenGpsReadings.default;
  }
});
Object.defineProperty(exports, "getStationId", {
  enumerable: true,
  get: function () {
    return _nestedReadings.default;
  }
});
Object.defineProperty(exports, "nestGpsReadings", {
  enumerable: true,
  get: function () {
    return _nestGpsReadings.default;
  }
});
var _nestGpsReadings = _interopRequireDefault(require("./nestGpsReadings"));
var _flattenGpsReadings = _interopRequireDefault(require("./flattenGpsReadings"));
var _deriveSkipReadings = _interopRequireDefault(require("./deriveSkipReadings"));
var _LocationType = _interopRequireDefault(require("./LocationType"));
var _EditReadings = _interopRequireDefault(require("./EditReadings"));
var _editing = _interopRequireDefault(require("./editing"));
var _nestedReadings = _interopRequireDefault(require("./nestedReadings"));
var _DateTimeless = _interopRequireDefault(require("../DateTimeless/DateTimeless"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const ReadingsUtil = {
  LocationType: _LocationType.default,
  flattenGpsReadings: _flattenGpsReadings.default,
  nestGpsReadings: _nestGpsReadings.default,
  deriveSkipReadings: _deriveSkipReadings.default,
  EditReadings: _EditReadings.default,
  Editing: _editing.default,
  getStationId: _nestedReadings.default
};
var _default = ReadingsUtil;
exports.default = _default;